import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';

const asyncStateClient = new QueryClient();

type Props = {
  children: ReactNode;
};

const AsyncStateProvider = ({ children }: Props) => (
  <QueryClientProvider client={asyncStateClient}>
    {children}
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);
export default {
  Provider: AsyncStateProvider,
};
